
import { authConstants } from "../actions/constants/authConstants";


export const authReducer = (state = {}, action: any) => {
    switch (action.type) {
        case authConstants.otpLoginRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case authConstants.otpLoginSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                authData: action.payload
            }
        case authConstants.otpLoginFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        case authConstants.userLogout:
            // Reset auth slice on logout
            return {
                isLoading: false,
                isSuccess: false,
                isError: false,
                authData: null
            }
        default:
            return state;
    }
}



export const acceptInvitationReducer = (state = {}, action: any) => {
    switch (action.type) {
        case authConstants.acceptInvitationRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case authConstants.acceptInvitationSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                userData: action.payload
            }
        case authConstants.acceptInvitationFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const otpverifyReducer = (state = {}, action: any) => {
    switch (action.type) {
        case authConstants.otpVerifyRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case authConstants.otpVerifySuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                authData: action.payload
            }
        case authConstants.otpVerifyFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        case authConstants.userLogout:
            return {
                isLoading: false,
                isSuccess: false,
                isError: false,
                authData: null
            }
        default:
            return state;
    }
}


export const resendReducer = (state = {}, action: any) => {
    switch (action.type) {
        case authConstants.resendOtpRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case authConstants.resendOtpSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                resendData: action.payload
            }
        case authConstants.resendOtpFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        case authConstants.userLogout:
            // Clear resend data on logout
            return {
                isLoading: false,
                isSuccess: false,
                isError: false,
                resendData: null
            }
        default:
            return state;
    }
}


export const renewTokenReducer = (state = {}, action: any) => {
    switch (action.type) {
        case authConstants.renewTokenRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case authConstants.renewTokenSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                renewData: action.payload
            }
        case authConstants.renewTokenFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        case authConstants.userLogout:
            // Clear token renewal data on logout
            return {
                isLoading: false,
                isSuccess: false,
                isError: false,
                renewData: null
            }
        default:
            return state;
    }
}

export const verifyTokenReducer = (state = {}, action: any) => {
    switch (action.type) {
        case authConstants.verifyTokenRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case authConstants.verifyTokenSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                verifyData: action.payload,
                isResponse: true
            }
        case authConstants.verifyTokenFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload,
                isResponse: true
            }
        default:
            return state;
    }
}

export const registerTenantReducer = (state = {}, action: any) => {
    switch (action.type) {
        case authConstants.registerTenantRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case authConstants.registerTenantSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                data: action.payload
            }
        case authConstants.registerTenantFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const verifyRegistrationReducer = (state = {}, action: any) => {
    switch (action.type) {
        case authConstants.verifyRegistrationRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case authConstants.verifyRegistrationSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                data: action.payload
            }
        case authConstants.verifyRegistrationFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}

export const checkTenantExistsReducer = (state = {}, action: any) => {
    switch (action.type) {
        case authConstants.checkTenantExistsRequest:
            return {
                isLoading: true,
                isSuccess: false,
                isError: false
            }
        case authConstants.checkTenantExistsSuccess:
            return {
                isLoading: false,
                isSuccess: true,
                isError: false,
                data: action.payload
            }
        case authConstants.checkTenantExistsFailure:
            return {
                isLoading: false,
                isSuccess: false,
                isError: true,
                error: action.payload
            }
        default:
            return state;
    }
}
